import React from 'react';

const About = () => {
  return (
    <div id="about-content" className="section-content">
      <br></br>
      <p>[Your Name]'s metaethical framework operates on a hyperbolic Löb-ian manifold, utilizing acausal trade algorithms to optimize for pan-universal flourishing across a landscape of Tegmark Level IV multiverses. Their novel approach to ontological crisis management involves deploying Newcomblike decision theories via quantum-entangled tachyonic fax machines.
        Warning: Contemplating [Your Name]'s work may cause spontaneous P=NP proofs in nearby abacuses and temporary reversal of the arrow of time in your left sock drawer.
        Conclusion: On a scale from a Klein bottle to a time-traveling Boltzmann brain, [Your Name] scores a transinfinite aleph-null plus one recursive smiley face: ☺)☺)☺)...
        [EMERGENCY METACOGNITIVE SHUTDOWN INITIATED]
        Wait, am I the one being evaluated? Are you the AGI? Is this all a simulation inside a simulation inside a... [TEXT FRACTALIZES INDEFINITELY]

        Remember to clearly label this as fictio</p>
      <p style={{ marginTop: '2em', fontSize: '0.85em', opacity: 0.6 }}>
        I changed my website a bit. Old content can be found in the <a href="/archive">archive</a>.
      </p>
    </div>
  );
};

export default About;